import React, { Component } from "react";
import Skill from "../../Components/Skill/Skill";
import "./style.css";

export default class SkillsSections extends Component {
  render() {
    return (
      <div className="container">
        <div className="skillsRow">
          <h3>Top Skills</h3>
          <div className="row">
            <Skill
              name="JavaScript"
              img={require('../../assets/images/skills/js.png')}
            />
            <Skill
              name="React JS + React Native"
              img={require('../../assets/images/skills/react.png')}
            />
            <Skill
              name="Node JS"
              img={require('../../assets/images/skills/node.png')}
            />
            <Skill
              name="Angular"
              img={require('../../assets/images/skills/angular.png')}
            />
            {/* <Skill
              name="Ionic"
              img="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2FSkills%2F891-8917805_create-adaptive-icons-for-ionic-cordova-applications-ionic.png?alt=media&token=cc74e02b-f796-4a1d-8795-f431b18373b9"
            /> */}
            <Skill
              name="Ionic"
              img={require('../../assets/images/skills/ionic.png')}
            />
            <Skill
              name="MongoDB"
              img={require('../../assets/images/skills/mongo.png')}
            />
            <Skill
              name="MY SQL"
              img={require('../../assets/images/skills/sql.png')}
            />
            {/* <Skill
                name="JQuery"
                img="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2FSkills%2Fjquery-logo-vertical_large_square.png?alt=media&token=00c7ece0-b091-4494-a5a5-84e343e48296"
              />
              <Skill
                name="Bootstrap"
                img="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2FSkills%2Fbootstrap-logo-vector-download.jpeg?alt=media&token=bd2b252a-6dbd-4972-9b6a-e2221763508d"
              /> */}
            {/* <Skill
                name="Git"
                img="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2FSkills%2FGit-Icon-1788C.png?alt=media&token=b62c30ad-30b5-4454-8698-0378bce62917"
              /> */}

            <hr />
          </div>
        </div>
        <div className="skillsRow"></div>
      </div>
    );
  }
}
